<template>
  <header
    v-show="showHeader"
    :class="{
      'shellHeader--behind': isBehind,
      'shellHeader--dark': theme === 'dark',
      'shellHeader--light': theme === 'light',
      'shellHeader--book': $route.name === 'Book',
      'shellHeader--bookLive': live && $route.name === 'Book'
    }"
    class="shellHeader"
  >
    <a href="/" class="shellHeader__logo" @click.prevent="scrollToTop">
      <h1>Saint Laurent</h1>
      <LogoSvg v-if="!isDesktop" />
      <LogoSvgD v-else />
    </a>
    <button
      v-show="$route.name !== 'Index' && $route.name !== 'NotFound'"
      @click="toggleMenu"
      :class="{
        'shellHeader__menuButton--close': isMenuOpen || isPopinOpen,
        'shellHeader__menuButton--popin': !isPopinOpen
      }"
      class="shellHeader__menuButton"
    >
      <span class="shellHeader__menuButtonIcon" />
    </button>
  </header>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import LogoSvg from '@/components/svg/logo.svg'
import LogoSvgD from '@/components/svg/logo-d.svg'
import gsap from 'gsap'

export default {
  name: 'ShellHeader',
  components: {
    LogoSvg,
    LogoSvgD
  },
  data() {
    return {
      isDesktop: false
    }
  },
  props: {
    live: {
      type: Number,
      required: false,
      default: 0
    },
    isBehind: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...mapState({
      isLiveYoutube: state =>
        state.configuration.live ? JSON.parse(state.configuration.live) : 0,
      theme: state => state.theme,
      isMenuOpen: state => state.isMenuOpen,
      isPopinOpen: state => state.isPopinOpen,
      showHeader: state => state.showHeader
    })
  },
  methods: {
    ...mapMutations({
      setMenuOpen: 'setMenuOpen',
      setPopinOpen: 'setPopinOpen'
    }),
    toggleMenu() {
      if (this.isPopinOpen) this.setPopinOpen(!this.isPopinOpen)
      else this.setMenuOpen(!this.isMenuOpen)
    },
    scrollToTop() {
      this.$bus.$emit('scrollToTop')
    },
    checkViewport() {
      this.isDesktop = window.innerWidth >= 768
    }
  },
  mounted() {
    this.checkViewport()
    gsap.fromTo(
      this.$el,
      {
        opacity: 0
      },
      {
        opacity: 1,
        duration: 1,
        ease: 'linear'
      }
    )
    window.addEventListener('resize', this.checkViewport)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkViewport)
  }
}
</script>

<style lang="scss">
.shellHeader {
  $self: &;
  justify-content: space-between;
  padding: 16.5px;
  width: 100%;
  position: relative;
  top: 0;
  z-index: 4;

  @media screen and (min-width: 768px) {
    pointer-events: none;
    height: 80px;
  }

  &__menuButton {
    pointer-events: auto;
  }

  &__logo {
    pointer-events: none;
  }

  // @media screen and (min-width: 768px) {
  //   align-items: flex-start;
  //   flex-direction: column;
  // }

  &--dark {
    color: var(--white);
    background-color: var(--black);

    @media screen and (min-width: 768px) {
      background-color: transparent;
    }
  }

  &--dark &__logo {
    color: white;
  }

  &--light {
    $self: &;
    color: var(--black);
    background-color: var(--white);

    @media screen and (min-width: 768px) {
      background-color: transparent;
    }
  }

  &--behind {
    z-index: 1;
  }

  &--book {
    //background: #fff;
    //display: block;
    pointer-events: auto;
    //z-index: 120;
    position: fixed;
    background-color: var(--white);
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (min-width: 768px) {
      color: var(--white);

      &Live {
        color: var(--black);
      }
    }
  }

  &__logo {
    display: block;
    margin: auto;

    svg {
      display: inherit;
      @media screen and (max-width: 768px) {
        //height: 16px;
        //width: 162px;
      }
    }

    h1 {
      height: 0;
      margin: 0;
      text-indent: -9999px;
      width: 0;
    }
  }

  &__menuButton {
    $button: &;
    background-color: transparent;
    border: unset;
    color: inherit;
    padding: 0;
    position: absolute;
    left: 20px;
    width: 24px;
    height: 24px;

    @media screen and (min-width: 768px) {
      left: 32px;
    }

    @media screen and (min-width: 768px) {
      &--popin:not(&--close) {
        display: none;
      }
      //   margin-top: 28px;
      //   transition: opacity 16ms steps(1) 500ms;
      //   opacity: 1;
    }

    // &Label {
    //   display: none;
    //   text-transform: uppercase;
    //   font-size: 10px;
    //   line-height: 12px;

    //   @media screen and (min-width: 768px) {
    //     display: block;
    //   }
    // }

    &Icon {
      @media screen and (min-width: 768px) {
        display: none;
      }

      &::before,
      &::after,
      span {
        background-color: currentColor;
        display: block;
        height: 1px;
        width: 16px;
      }

      &::before,
      &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 4px;
      }

      &::before {
        transform: translateY(-4.5px);
      }

      &::after {
        transform: translateY(4.5px);
      }
    }

    &--close {
      @media screen and (max-width: 767px) {
        transform: translateY(-1px);
      }

      // @media screen and (min-width: 768px) {
      //   transition-delay: 0s;
      //   opacity: 0;
      //   pointer-events: none;
      // }

      #{$button}Icon {
        &::before {
          transform: translateY(0) rotateZ(-45deg);
        }

        &::after {
          transform: translateY(0) rotateZ(45deg);
        }

        span {
          visibility: hidden;
        }
      }
    }
  }
}
</style>
